var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _vm.countries
      ? _c("div", [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "form",
                {
                  attrs: { action: "" },
                  on: { submit: _vm.getRejectedOrders },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-2" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Страна закупки"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedCountry,
                                expression: "selectedCountry",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedCountry = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.countries, function (name, index) {
                            return _c(
                              "option",
                              { domProps: { value: index } },
                              [_vm._v(_vm._s(name))]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Статистика за кол. дней"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.days,
                              expression: "days",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number", required: "" },
                          domProps: { value: _vm.days },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.days = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Сортировка"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.sorting,
                                expression: "sorting",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.sorting = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function ($event) {
                                  return _vm.sortedDrugs(_vm.sorting)
                                },
                              ],
                            },
                          },
                          [
                            _c("option", { attrs: { value: "name" } }, [
                              _vm._v("По алфавиту"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "fresh_order_time" } },
                              [_vm._v("По дате заявок")]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(
                            "Слова, которые встречаются в причине отказа (через запятую)"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.words,
                              expression: "words",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", required: "" },
                          domProps: { value: _vm.words },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.words = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._m(0),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 text-right" },
                      [
                        _c(
                          "vue-ladda",
                          {
                            attrs: {
                              "button-class": "btn btn-info",
                              "data-style": "zoom-in",
                              loading: _vm.btnLoading,
                            },
                            on: { click: _vm.getRejectedOrders },
                          },
                          [_vm._v("Показать\n                            ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c("pulse-loader", {
                    attrs: { loading: _vm.loading, color: _vm.color },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.loading
                ? _c("div", [
                    _c(
                      "table",
                      { staticClass: "table table-hover table-striped" },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.drugs, function (drug, index) {
                            return _c("tr", [
                              _c("td", [_vm._v(_vm._s(index + 1))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(drug.name) +
                                    " (" +
                                    _vm._s(drug.id) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                _vm._l(drug.orders, function (order) {
                                  return _c("p", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(order.id) +
                                          " (" +
                                          _vm._s(order.qty) +
                                          ")"
                                      ),
                                    ]),
                                    _vm._v(": "),
                                    _c("small", { staticClass: "text-muted" }, [
                                      _vm._v(_vm._s(order.created)),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(order.text),
                                      },
                                    }),
                                  ])
                                }),
                                0
                              ),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("small", [
        _vm._v(
          'Учитывается регистр текста, если хотите указать слово "склад", то добавьте и "Склад"'
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Заявки")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }